export default "__VITE_ASSET__CrDEgRMu__";